var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MoHeader"},[_c('div',{staticClass:"logoImage"},[_c('img',{staticClass:"logo",attrs:{"src":"xcLogo.svg"}}),_c('img',{attrs:{"src":require("@/assets/images/email.png")}})]),_c('div',{staticClass:"Icon"},[_c('img',{attrs:{"src":require("@/assets/images/email.png")}}),_c('img',{attrs:{"src":require("@/assets/images/phone.png")}})])])
}]

export { render, staticRenderFns }